import { 
    createSlice, 
    createAsyncThunk,  
    createEntityAdapter,  
} from '@reduxjs/toolkit'
import { Pager } from '../../../lib/js-apiclient/src/response/Pager';
import { WooCommerceModel } from '../models/woocommerce/WooCommerceModel';


const wooCommerceTermAdapter = createEntityAdapter({})

export const wooCommerceTermApi = {
    _model: null,
    _getToken: (thunkAPI) => {
        return thunkAPI.getState().identityReducer.token.signature;
    },
    fetchAll: createAsyncThunk(
        'woocommerce/term/fetchAll', 
        async ({channelId, attributeId, page, term}, thunkAPI) => {
            try {
                const token = wooCommerceTermApi._getToken(thunkAPI);
                const wchModel = new WooCommerceModel(token, channelId);

                /** @type {Pager} */
                const pager = await wchModel.getTerms(attributeId, page, term);
                
                return {
                    hasPrevPage: pager.hasPrevPage,
                    hasNextPage: pager.hasNextPage,
                    entities: pager.getEntities()
                }
            } catch (apiError) {
                return thunkAPI.rejectWithValue(apiError.toJson());
            }
        }
    ),
}

const wooCommerceTermSlice = createSlice({
    name: "woocommerce/term",
    initialState: wooCommerceTermAdapter.getInitialState({
        status: 'idle',
        error: null,
        showMore: true,
    }),
    reducers: {
        clearTermList(state, action) {
            wooCommerceTermAdapter.removeAll(state);
        },
    },
    extraReducers: {
        [wooCommerceTermApi.fetchAll.fulfilled]: (state, action) => {
            state.status = 'woocommerce/term/fetchAll/succeeded'

            if(action.payload.hasPrevPage) {
                wooCommerceTermAdapter.addMany(state, action.payload.entities)
            } else {
                wooCommerceTermAdapter.setAll(state, action.payload.entities)
            }

            state.showMore = action.payload.hasNextPage;
            state.error = null;
        },
        [wooCommerceTermApi.fetchAll.rejected]: (state, action) => {
            state.status = 'woocommerce/term/fetchAll/rejected'
            state.error = action.payload
        },
    }
});

export const {
    selectAll: selectAllWooCommerceTerm,
} = wooCommerceTermAdapter.getSelectors((state) => state.wooCommerceTermReducer)

export const { clearTermList } = wooCommerceTermSlice.actions;

export default wooCommerceTermSlice.reducer;
